<div *ngIf="showImage" [ngClass]="isHome ? 'brand-container-home' : 'brand-container'">
    <img src="{{ srcImage }}" alt="{{ altImage }}" width="100%" height="60" />
</div>
